import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import IntroPage from './pages/IntroPage';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SketchbookPage from './pages/SketchbookPage';
import VisitorGalleryPage from './pages/VisitorGalleryPage';
import OnboardingPage from './pages/OnboardingPage';
import CaseStudyPage from './pages/CaseStudyPage';
import InteractiveMascot from './components/InteractiveMascot';
import CustomCursor from './components/CustomCursor';
import { VisitorAccentColorProvider } from './hooks/useVisitorAccentColor';

const GA_MEASUREMENT_ID = 'G-X1V9GVFBZ9';

function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isDarkBackground = location.pathname === '/';

  return (
    <>
      <GoogleAnalyticsTracker />
      <Routes>
        <Route path="/" element={<IntroPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/sketchbook" element={<SketchbookPage />} />
        <Route path="/visitor-gallery" element={<VisitorGalleryPage />} />
        <Route path="/work/:slug" element={<CaseStudyPage />} />
      </Routes>
      <CustomCursor />
      <InteractiveMascot isDarkBackground={isDarkBackground} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VisitorAccentColorProvider>
          <AppContent />
        </VisitorAccentColorProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
